import React, { useState, useEffect } from 'react';

interface HistoryItem {
    id: number;
    action_type: string;
    description: string;
    created_at: string;
    username: string; // Joined from users table
}

interface HistoryModalProps {
    requestId: number;
    onClose: () => void;
}

const HistoryModal: React.FC<HistoryModalProps> = ({ requestId, onClose }) => {
    const [history, setHistory] = useState<HistoryItem[]>([]);
    const [newNote, setNewNote] = useState('');

    useEffect(() => {
        fetchHistory();
    }, [requestId]);

    const fetchHistory = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`/api/admin/history/${requestId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setHistory(data);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleAddNote = async () => {
        if (!newNote.trim()) return;

        try {
            const token = localStorage.getItem('token');
            const res = await fetch('/api/admin/history', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ requestId, description: newNote })
            });

            if (res.ok) {
                setNewNote('');
                fetchHistory();
            } else {
                alert('메모 저장 실패');
            }
        } catch (e) {
            console.error(e);
            alert('오류 발생');
        }
    };

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1100
        }}>
            <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '500px', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ margin: '0 0 15px 0' }}>업무 히스토리 / 비고</h3>

                <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #ddd', padding: '10px', marginBottom: '15px' }}>
                    {history.length === 0 ? (
                        <p style={{ color: '#aaa', textAlign: 'center' }}>기록이 없습니다.</p>
                    ) : (
                        history.map(item => (
                            <div key={item.id} style={{ marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>
                                <div style={{ fontSize: '12px', color: '#888', marginBottom: '2px' }}>
                                    {new Date(item.created_at).toLocaleString()} | {item.username || 'Unknown'} | {item.action_type}
                                </div>
                                <div style={{ fontSize: '14px' }}>{item.description}</div>
                            </div>
                        ))
                    )}
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                    <input
                        type="text"
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                        placeholder="메모 입력..."
                        style={{ flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                        onKeyPress={(e) => e.key === 'Enter' && handleAddNote()}
                    />
                    <button onClick={handleAddNote} style={{ padding: '8px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                        등록
                    </button>
                </div>

                <button onClick={onClose} style={{ marginTop: '10px', padding: '8px', cursor: 'pointer', backgroundColor: '#eee', border: 'none', borderRadius: '4px' }}>
                    닫기
                </button>
            </div>
        </div>
    );
};

export default HistoryModal;
